import React, { Fragment, useState, useRef, useEffect } from "react";
import {
  Box,
  Heading,
  Card,
  CardBody,
  Input,
  Text,
  Select,
  Flex,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Image,
  Spinner,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Switch,
} from "@chakra-ui/react";
import { RxDotFilled } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../style/datePicker.css";
import { BiArrowBack } from 'react-icons/bi';
import { v4 as uuid } from "uuid";
import { Auth } from "../../component/Auth";
import { AiOutlineConsoleSql } from "react-icons/ai";


const CreateOrder = () => {
  const [toggle, setToggle] = useState(false);
  const [selectedProductToggle, setSelectedProductToggle] = useState(false);
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [orderDetails, setOrderDetails] = useState({});
  const [price, setPrice] = useState(orderDetails?.price || "");
  const [orderGSTNumber, setOrderGSTNumber] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [OrderAmount, setOrderAmount] = useState(""); // Item Price * No of days before month end & item price * no of weeks / 7
  const [refundableAmount, setRefundableAmount] = useState("");
  const [typeOfTenure, setTypeOfTenure] = useState("");
  const [tenurePeriod, setTenurePeriod] = useState("");
  const [discountVal, setDiscountVal] = useState("");
  const [quantityValue, setQuantityValue] = useState(1)
  const [quantityError, setQuantityError] = useState(false)
  const [isVerified, setIsVerified] = useState(true)
  const [productType, setProductType] = useState(""); // product type [weekly, monthly
  const quantityArr = []

  
  for (let i = 1; i <= quantityValue; i++) {
    quantityArr.push(i);
  }

  // error state
  const [priceError, setPriceError] = useState(false);
  const [pricePosError, setPricePosError] = useState(false)
  const [productError, setProductError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [refundableError, setRefundableError] = useState(false);
  const [refundablePosError, setRefundablePosError] = useState(false)
  const [discountError, setDiscountError] = useState(false);
  const [discountPosError, setDiscountPosError] = useState(false)
  const [typeOfTenureError, setTypeOfTenureError] = useState(false);
  const [tenurePeriodError, setTenurePeriodError] = useState(false);
  
  const productContainer = useRef(null);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const periodInputs = {
    week: [1, 2, 3, 4],
    month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  };

  // clear session storage
  window.sessionStorage.removeItem('order_summary')
  window.sessionStorage.removeItem("billing_Address_response")
  window.sessionStorage.removeItem("shipping_Address_response")
  window.sessionStorage.removeItem("shipping_Address_payload")
  window.sessionStorage.removeItem("billing_Address_payload")
  window.sessionStorage.removeItem("customer_data")
  //   save create order details handler
  const saveHandler = () => {
    if (
      orderDetails?.productId &&
      orderDetails?.variantID &&
      orderDetails?.productName &&
      orderDetails?.variantTitle &&
      price !== "" &&
      startDate !== "" &&
      refundableAmount !== "" &&
      discountVal !== "" &&
      typeOfTenure !== "" &&
      tenurePeriod !== "" &&
      quantityValue !== "" &&
      discountPosError === false &&
      refundablePosError === false &&
      pricePosError === false 
    ) {
      const shopifyCheckoutToken_id = uuid();
      const shopifyOrderId_id = uuid();
      const item_id = uuid();
      // const dateObj = new Date(endDate);
      const startDateObj = new Date(startDate)
      // const endDateString = `${
      //   // dateObj.getMonth() + 1
      //   dateObj.getMonth() + 1
      //   }/${dateObj.getDate()}/${dateObj.getFullYear()}`;

      const startDateString = `${
        // dateObj.getMonth() + 1
        startDateObj.getMonth() + 1
        }/${startDateObj.getDate()}/${startDateObj.getFullYear()}`;


      // -------------------------- Store In Session Storage--------------------------- //
      window.sessionStorage.setItem("order_summary", JSON.stringify({
        pacedDate: new Date().toISOString(),
        orderStatusId: "ORDER_DRAFT",
        enteredByPartyId: "",
        customerPartyId: "",
        recurrAutoInvoice: 0,
        grandTotal: 0,
        OrderName: `test-order-ralco`,
        orderGstNumber:`${orderGSTNumber?.length === 0 ? 'n/a' : orderGSTNumber}`,
        // shippingAddressId: "JD_DEMO_ADDRESS_01",
        // billingAddressId: "JD_DEMO_ADDRESS_01",
        shopifyCheckoutToken: `${shopifyCheckoutToken_id}`,
        delivery_date: `${startDate}`,
        isAutoVerified: !isVerified,
        shopifyOrderId: shopifyOrderId_id,
        orderItems: // passing [{},{},{}] to orderItems
          // passing json obj for each qty, if qty of orderItem is 3 the 3 orderItem with same details created
          quantityArr.map(() => JSON.stringify({
            itemId: item_id,
            productId: `${orderDetails?.productId}`,
            productVariantId: `${orderDetails?.variantID}`,
            productHandle: `${orderDetails?.productHandle}`,
            statusId: "ORDER_DRAFT",
            unitListPrice: Number((orderDetails?.price)),
            unitPrice: Number((orderDetails?.price)),
            totalPrice: Number((Number(OrderAmount))), // (unit price * no of days ) - discounted amount
            // discount: Number((Number(discountVal))),
            discount: (Number(OrderAmount) * (Number(discountVal) / 100)),
            subtotal: Number(((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100)))).toFixed(2)),
            finalPrice: Number(Number(refundableAmount) + Number(((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))))) + Number((Number(OrderAmount - (Number(OrderAmount) * (Number(discountVal) / 100))) * 0.18))).toFixed(2) * 1,
            title: orderDetails?.productName,
            variant: orderDetails?.variantTitle,
            productImg: orderDetails?.img,
            quantity: 1,//Number(quantityValue)
            isPromo: false,
            comment: "",
            refundableDeposit: Number(refundableAmount),
            tenure: {
              startDate: `${startDateString}`,
              endDate: `${endDate}`,
              tenurePeriodType: `${typeOfTenure.toUpperCase()}`,
              tenurePeriod: tenurePeriod,
              weeks: typeOfTenure === "weekly" ? Number(tenurePeriod) : 0,
              months: typeOfTenure === "monthly" ? Number(tenurePeriod) : 0,
              pricePerWeek: typeOfTenure === "weekly" ? Number((OrderAmount -
                (OrderAmount * (Number(discountVal)) / 100)) / Number(tenurePeriod)) : 0.00,
              pricePerMonth: tenureAmount(),
              pricePerYear: 0.0,
              billingDate: null
            },
          }
          )).map((qty) => JSON.parse(qty))
      }))

      setSelectedProductToggle(false);
      setProductError(false);
      navigate('/orders/create-order/summary')
    } else {
      if (
        !orderDetails?.productId &&
        !orderDetails?.variantID &&
        !orderDetails?.productName &&
        !orderDetails?.variantTitle
      ) {
        setProductError(true);
      }
      if (startDate === "") {
        setStartDateError(true);
      }
      if (price === "") {
        setPriceError(true);
      }
     
      if (refundableAmount === "") {
        setRefundableError(true);
      }
      if (discountVal === "") {
        setDiscountError(true);
      }
      if (tenurePeriod === "") {
        setTenurePeriodError(true);
      }
      if(quantityValue === ""){
        setQuantityError(true)
      }
      if (typeOfTenure === "") {
        setTypeOfTenureError(true);
      }
    }
  };

// convert end date 
const convertEndDate = (originalDateString) => {
  const originalDate = new Date(originalDateString);
  const day = originalDate.getDate();
  const month = originalDate.getUTCMonth() + 1; // Months are 0-indexed, so we add 1
  const year = originalDate.getUTCFullYear();

const formattedDate = `${day}/${month}/${year}`;
return formattedDate
}

  //   functionality to hide product dropdown
  const handleClickOutside = (event) => {
    if (
      productContainer.current &&
      !productContainer.current.contains(event.target)
    ) {
      if (!event.target.tagName.toLowerCase().match(/input|label/)) {
        setToggle(false);
      }
    }
  };
  // Dropdown useEffect
  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Unbind the event listener on cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Product handler & response json

  const getProductMetaFields = async (productId, variantId) => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_RALCO_API_URL}/api/product/get-shopify-product-metafields/${productId}`, {
        method: "GET",
        headers: {
          'Authorization': Auth()
        }
      });
      let data = await response.json();
      setPrice(getDailyPriceFromMetaFields(data.metafields, variantId))
    } catch (error) {  
      console.log(error);
    }
  }

  const setFinalPrice = () => {
    if ((typeOfTenure == "weekly" && productType == "monthly" && process.env.REACT_APP_PRO_RATA_ENABLED === 'false') || process.env.REACT_APP_PRO_RATA_ENABLED === 'true') {
      if (!price) {
        getProductMetaFields(orderDetails?.productId, orderDetails?.variantID);
      }
    } else {
      if (!price) {
        setPrice(() => orderDetails?.price || "");
      }
    }
  }

  const getDailyPriceFromMetaFields = (metafields, variantId) => {
    const variant = JSON.parse(metafields.find(item => item.key === 'daily_price_json').value).find(item => item.variantId === variantId)
    console.log(variant, 'variant here')
    return variant.price * 1.0
  }

  const productHandler = async (e) => {
    e.stopPropagation();
    setToggle(true);
    try {
      let response = await fetch(
        `${process.env.REACT_APP_RALCO_API_URL}/api/product/get-shopify-products`, {
        method: "GET",
        headers: {
          'Authorization': Auth()
        }
      }
      );
      let data = await response.json();
      data = data && data.products.filter((x)=>x.status === "active").filter((x)=>!x.title.includes("Refundable"))
      console.log(data, 'products here')
      setProducts(data);
    } catch (error) {
      console.log(error);
    }
  };

  const tenureAmount = () => {
    if (typeOfTenure === "weekly") return 0.0;
    const subtotal = (OrderAmount * (1 - (discountVal / 100)));
    return subtotal
  }

  // ---- set price for price input value ---
  useEffect(() => {
    //  ---- Start Date to End Date Calculations -------
    const endDateCalculation = (date, duration) => {
      // Define the start date and duration

      const startDate = new Date(date);
      const durationDays =
        typeOfTenure === "weekly" ? duration * 7 : duration * 30;
      // Weekly Calculation Condition - if block
      if (typeOfTenure === "weekly" && tenurePeriod?.length > 0) {
        // Calculate the end date of week
        let endDate = new Date(
          startDate.getTime() + (durationDays) * 24 * 60 * 60 * 1000
        );
        const endDateObj = new Date(endDate);
        endDate = `${endDateObj.getDate()}/${endDateObj.toLocaleString(
          "default",
          { month: "short" }
        )}/${endDateObj.getFullYear()}`;
        // Weekly days * amount
        setOrderAmount(calculateNoOfDays(endDate, startDate));
        return endDate;
        // Monthly Calculation Condition - else block
      } else if (typeOfTenure === "monthly" && tenurePeriod?.length > 0) {
    
        let myDate = new Date(date);
        myDate.setHours(18);
        myDate.setMinutes(30);
        myDate.setSeconds(0);
        
        let startDate = new Date(myDate);
        let monthDuration = Number(duration);
        let endDate = new Date(startDate);
        
        console.log('REACT_APP_PRO_RATA_ENABLED', process.env.REACT_APP_PRO_RATA_ENABLED)
        
        if (process.env.REACT_APP_PRO_RATA_ENABLED === 'false') {
        
          // Calculate the end date of the month with the specified duration
          let endMonth = (((startDate.getMonth() + monthDuration) % 12));
          let endYear = startDate.getFullYear() + Math.floor((startDate.getMonth() + monthDuration) / 12);
          // Calculate the last day of the calculated month
          endDate.setFullYear(endYear, endMonth, startDate.getDate());
          setOrderAmount(price);
          return date.length === 0 ? null : endDate.toISOString();
        } else {
        
          if (startDate.getDate() > 1 || monthDuration > 1) {
            // Calculate the end date of the month with the specified duration
            let firstDayMonth = ((startDate.getMonth() === 0) && (startDate.getDate()) === 1 ) ? (startDate.getMonth() - 1) : startDate.getMonth() 
            let endMonth = (((startDate.getMonth() + (startDate.getDate() > 1 ? 0 : -1)) + monthDuration) % 12);
            let endYear = startDate.getFullYear() + Math.floor((firstDayMonth + monthDuration) / 12);
            console.log(startDate.getMonth(), ' ', startDate.getDate())
            // Calculate the last day of the calculated month
            let lastDay = new Date(endYear, endMonth + 1, 0).getDate();
            
            endDate.setFullYear(endYear, endMonth, lastDay);
          } else {
            // Calculate the last day of the current month
            const currentMonth = startDate.getMonth();
            const currentYear = startDate.getFullYear();
            const lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
            
            endDate = new Date(currentYear, currentMonth, lastDay + 1);
          }
        }
        
        setOrderAmount(remainingDaysInMonth(new Date(date)));
        return date.length === 0 ? null : endDate.toISOString();
      }
      
    };

    // Calculate the number of days in weekly
    const calculateNoOfDays = (endDate, startDate) => {
      // 
      const timeDiff =
        new Date(endDate).getTime() - new Date(startDate).getTime();
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      // 
      return (diffDays) * price;
    };
    // Calculate the number of remaining days in month
    const remainingDaysInMonth = (date) => {
      
      const year = date.getFullYear();
      // const month = date.getMonth() + 1;
      const month = date.getMonth() + 1;
      const day = date.getDate();
      
      const numDaysInMonth = new Date(year, month, 0).getDate();
      let remainingDays = numDaysInMonth - day;
      // console.log(remainingDays + 1, '55555555555555555555')
      // remainingDays += 1
      return day === 1 ? 30 * price : remainingDays * price;
    };

    // Set the default price when orderDetails change
    setFinalPrice()
    // setPrice(price || orderDetails?.price || "");

    setEndDate(endDateCalculation(startDate, tenurePeriod));

  }, [orderDetails, tenurePeriod, startDate, typeOfTenure, endDate]);

  // --- Sunday date disabled & end of 5 days & specific date of month functionality ------
  const isWeekend = (date) => {
    if (
      JSON.parse(window.sessionStorage.getItem("filterWeekend"))?.sunday ===
      true &&
      JSON.parse(window.sessionStorage.getItem("filterWeekend"))?.saturday ===
      true
    ) {
      return date.getDay() !== 6 && date.getDay() !== 0;
    }
    else if (
      JSON.parse(window.sessionStorage.getItem("filterWeekend"))?.saturday ===
      true
    ) {
      return date.getDay() !== 6;
    }
    else if (
      JSON.parse(window.sessionStorage.getItem("filterWeekend"))?.sunday ===
      true
    ) {
      return date.getDay() !== 0;
    }
    else {
      return 1;
    }
  };
  // specific date & last of days in month disabled logic
  const isDayDisabled = (date) => {
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const daysToEndOfMonth = lastDayOfMonth.getDate() - date.getDate() + 1;
    // Check if the date is in the disabledDates array
    if (
      JSON.parse(window.sessionStorage.getItem("filterDate"))?.some(
        (disabledDate) => new Date(disabledDate).getTime() === date.getTime()
      )
    ) {
      return true;
    }
    return (
      daysToEndOfMonth <=
      Number(JSON.parse(window.sessionStorage.getItem("endMonthDisable")))
    );
  };
  const filterDays = (day) => {
    return !isDayDisabled(day) && isWeekend(day);
  };

  const [refreshKey, setRefreshKey] = useState(0)

  return (
    <Fragment>
      <Box p={5} flex="1" w={"100%"} m={"auto"}>
        <Flex justifyContent={"space-between"} mb={4}>
          <Flex alignItems={'center'} justifyContent={'space-between'}>
            <BiArrowBack onClick={onOpen} fontSize={'32px'} style={{ cursor: "pointer" }} />
            <Heading fontSize={"28px"} ml={4}>Create Order</Heading>
          </Flex>
          {/* Auto Verified */}
          <FormControl mt={2} width={'auto'}>
            <FormLabel
              as={'div'}
              display={'flex'}
              fontSize={"17px"}
              mb={1}
              fontWeight={"semibold"}
              letterSpacing={"wide"}
              justifyContent={'flex-end'}
              alignItems={'center'}
            >
              Auto Verified  <Switch ml={2} mt={'2px'} value={!isVerified} onChange={(e) => {
                if (e.target.checked) {
                  setIsVerified(false)
                } else {
                  setIsVerified(true)
                }
              }} />
            </FormLabel>

          </FormControl>
          <Box>

            <Button
              bgColor={"white"}
              mr={3}
              size={"sm"}
              px={6}
              shadow={"md"}
              rounded={"sm"}
              onClick={onOpen}
            >
              Discard
            </Button>
            <AlertDialog
              isOpen={isOpen}
              onClose={onClose}
              motionPreset="slideInBottom"
              isCentered
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    Discard Order
                  </AlertDialogHeader>

                  <AlertDialogBody>
                    Are you sure? You can't undo this action afterwards.
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                      colorScheme="red"
                      onClick={() => navigate("/orders/all")}
                      ml={3}
                    >
                      Discard
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
            <Button
              colorScheme="twitter"
              size={"sm"}
              px={6}
              shadow={"md"}
              rounded={"sm"}
              onClick={saveHandler}
            >
              Create
            </Button>
          </Box>
        </Flex>
        <Flex justifyContent={"space-between"} flexDirection={"row"}>
          {/* Create Order Form Fields */}
          <Box flexBasis={"58%"}>
            <Card>
              <CardBody>
                <FormControl position={"relative"} isInvalid={productError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Products
                  </FormLabel>
                  <Input
                    placeholder={"Search products"}
                    name={"search-Product"}
                    onClick={(e) => {
                      productHandler(e);
                    }}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  {selectedProductToggle && (
                    <Text
                      color={orderDetails ? "green.500" : "red.500"}
                      ml={1}
                      mb={1}
                    >{`${orderDetails?.productName ||
                      "Please select product variant"
                      }  ${orderDetails?.variantTitle || ""}`}</Text>
                  )}
                  {productError && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please select product variant
                    </Text>
                  )}

                  {/* Add & Search Product */}
                  {toggle && (
                    <Box
                      ref={productContainer}
                      position={"absolute"}
                      zIndex={"99"}
                      bgColor={"white"}
                      width={"100%"}
                      border="1px"
                      borderColor="gray.300"
                      rounded={"md"}
                      maxHeight={`${window.innerHeight - 255}px`}
                      overflowY={"scroll"}
                      overflowX={'hidden'}
                    // css={{
                    //   "&::-webkit-scrollbar": { display: "none" },
                    //   scrollbarWidth: "none",
                    //   msOverflowStyle: "none",
                    // }}
                    >
                      {products?.length > 0 ? (
                        <Box mt={3}>
                          <Flex flexDirection={"column"}>
                            {products
                              .filter((e) =>
                                e.title
                                  .toLowerCase()
                                  ?.includes(query.toLocaleLowerCase())
                              )
                              .map((data, index) => {
                                return (
                                  <Fragment key={index}>
                                    <Box
                                      key={index}
                                      _hover={{
                                        bgColor:
                                          data.variants?.length === 1 &&
                                          "gray.100",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        setOrderDetails(
                                          data.variants?.length === 1
                                            ? {
                                              productName: data.title,
                                              productHandle: data.handle,
                                              productId: data.variants[0]?.product_id,
                                              variantTitle: data.variants[0]?.title,
                                              variantID: data.variants[0]?.id,
                                              price: data.variants[0]?.price,
                                              img: data.images[0]?.src
                                            }
                                            : null
                                        );
                                        setPrice(data.variants[0]?.price)
                                        setSelectedProductToggle(true);
                                        setToggle(false);
                                        setQuery("")
                                        setPriceError(false);
                                        setProductError(false);
                                        e.stopPropagation();
                                      }}
                                    >
                                      {/* product name */}
                                      <Flex
                                        flexDirection={
                                          data.variants?.length === 1
                                            ? "row"
                                            : "column"
                                        }
                                        py={data.variants?.length === 1 && 2}
                                      >
                                        <Flex
                                          flexBasis={"70%"}
                                          flexDirection={"row"}
                                          alignItems={"center"}
                                          px={3}
                                          mb={data.variants?.length > 1 && 1}
                                        >
                                          <Image
                                            height={12}
                                            width={16}
                                            borderRadius={"2px"}
                                            src={data.images[0]?.src}
                                          />
                                          <Box>
                                            <Text
                                              ml={3}
                                              fontWeight={"semibold"}
                                            >
                                              {data.title}
                                            </Text>
                                            {data.variants?.length === 1 && (
                                              <Text ml={3} fontSize={"13px"}>
                                                {data.variants[0].title}
                                              </Text>
                                            )}
                                          </Box>
                                        </Flex>
                                        {data.variants?.length === 1 ? (
                                          <Flex
                                            alignItems={"center"}
                                            justifyContent={"end"}
                                            flexBasis={"30%"}
                                            pr={3}
                                          >
                                            <Text fontWeight={"semibold"}>
                                              ₹{data.variants[0].price}
                                            </Text>
                                          </Flex>
                                        ) : (
                                          data.variants.map((d, i) => {
                                            return (
                                              <Fragment key={i}>
                                                <Flex
                                                  w={"100%"}
                                                  justifyContent={"end"}
                                                  py={2}
                                                  _hover={
                                                    data.variants?.length > 1
                                                      ? {
                                                        bgColor: "gray.100",
                                                        cursor: "pointer",
                                                      }
                                                      : null
                                                  }
                                                  onClick={(e) => {
                                                    setOrderDetails({
                                                      productName: data.title,
                                                      productId: d.product_id,
                                                      productHandle: data.handle,
                                                      variantTitle: d.title,
                                                      variantID: d.id,
                                                      price: d.price,
                                                      img: data.images[0]?.src,
                                                    });
                                                    
                                                    setProductType(
                                                      data.tags.includes(
                                                        "Monthly"
                                                      )
                                                        ? "monthly"
                                                        : "weekly"
                                                    );

                                                    setSelectedProductToggle(
                                                      true
                                                    );
                                                    setPrice(d.price)
                                                    setToggle(false);
                                                    setQuery("")
                                                    setPriceError(false);
                                                    setProductError(false);
                                                    e.stopPropagation();
                                                  }}
                                                >
                                                  <Flex
                                                    flexBasis={"100%"}
                                                    flexDirection={"row"}
                                                    alignItems={"center"}
                                                    marginLeft={2}
                                                  >
                                                    <RxDotFilled
                                                      color={"gray"}
                                                    />
                                                    <Text
                                                      fontSize={"14px"}
                                                      color={"gray.500"}
                                                    >
                                                      {d.title}
                                                    </Text>
                                                  </Flex>
                                                  <Flex
                                                    alignItems={"center"}
                                                    justifyContent={"end"}
                                                    flexBasis={"30%"}
                                                    pr={3}
                                                  >
                                                    <Text
                                                      fontSize={"14px"}
                                                      color={"gray.500"}
                                                    >
                                                      ₹{d.price}
                                                    </Text>
                                                  </Flex>
                                                </Flex>
                                                <Divider
                                                  m={0}
                                                  border={"1px solid gray"}
                                                  _last={{
                                                    marginBottom: "8px",
                                                  }}
                                                />
                                              </Fragment>
                                            );
                                          })
                                        )}
                                      </Flex>
                                    </Box>
                                    {data.variants?.length === 1 && (
                                      <Divider
                                        my={2}
                                        border={"1px solid gray"}
                                      />
                                    )}
                                  </Fragment>
                                );
                              })}
                          </Flex>
                        </Box>
                      ) : (
                        <Box textAlign={"center"}>
                          <Spinner my={4} />
                        </Box>
                      )}
                    </Box>
                  )}
                </FormControl>
                <FormControl my={2} >
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Quantity
                  </FormLabel>
                  <NumberInput onChange={(value) => {
                    value > 9999 ? setQuantityValue(1) : setQuantityValue(value.toString())
                    if(value === ''){
                      setQuantityError(true)
                    }else{
                      setQuantityError(false)
                    }
                    // setPrice(parseFloat(orderDetails?.price * value.toString()).toFixed(2))
                  }} min={1} max={9999} isDisabled={orderDetails?.price === undefined} value={quantityValue} >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                  {(quantityError || quantityError) && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please enter the <Text as="span" color={"red.500"} mb={1}> quantity at least 1</Text>
                    </Text>
                  )}
                </FormControl>
                <FormControl my={2} isInvalid={priceError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Price
                  </FormLabel>
                  <Input
                    type="number"
                    step="any"
                    placeholder={"Price"}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    name={"price"}
                    value={price}
                    autoComplete="off"
                    onChange={(event) => {
                      const newPrice = event.target.value;
                      setPrice(newPrice);
                      setPriceError(false);
                      setOrderDetails({
                        ...orderDetails,
                        price: newPrice,
                      });
                      
                      if (newPrice !== "") {
                        setPriceError(false);
                      } else {
                        setPriceError(true);
                      }
                      
                      if (Number(newPrice) >= 0) {
                        setPricePosError(false);
                      } else {
                        setPricePosError(true);
                      }
                    }}
                  />
                  {(priceError || pricePosError) && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please enter price <Text as="span" color={"red.500"} mb={1}> with positive number</Text>
                    </Text>
                  )}
                </FormControl>
                {/* ORDER GST NUMBER */}
                <FormControl my={2}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Order GST Number
                  </FormLabel>
                  <Input
                    placeholder={"Enter Order GST Number"}
                    name={"orderGSTNumber"}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    value={orderGSTNumber}
                    autoComplete="off"
                    onChange={(event) => {
                      setOrderGSTNumber(event.target.value);
                      setOrderDetails({
                        ...orderDetails,
                        orderGSTNumber: event.target.value,
                      });
                     
                    }}
                  />
                </FormControl>

                {/* Type of tenure */}
                <FormControl my={2} isInvalid={typeOfTenureError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Type of Tenure
                  </FormLabel>
                  <Select
                    name={"typeOfTenure"}
                    placeholder="Select type of tenure"
                    value={typeOfTenure}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    onChange={(e) => {
                      setTypeOfTenure(e.target.value);
                      setTenurePeriod("")
                      setOrderAmount("")
                      if (e.target.value === "") {
                        setTypeOfTenureError(true);
                      } else {
                        setTypeOfTenureError(false);
                      }
                    }}
                  >
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </Select>
                  {typeOfTenureError && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please select tenure period
                    </Text>
                  )}
                </FormControl>
                <FormControl my={2} isInvalid={tenurePeriodError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Tenure Period
                  </FormLabel>
                  <Select
                    placeholder={"Select duration"}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    name={"tenurePeriod"}
                    value={tenurePeriod}
                    onChange={(e) => {
                      setTenurePeriod(e.target.value);

                      if (e.target.value === "") {
                        setTenurePeriodError(true);
                      } else {
                        setTenurePeriodError(false);
                      }
                    }}
                  >
                    {(typeOfTenure === "weekly"
                      ? periodInputs.week
                      : periodInputs.month
                    ).map((element, index) => {
                      return (
                        <option key={index} value={element}>
                          {element}
                        </option>
                      );
                    })}
                  </Select>
                  {tenurePeriodError && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please select tenure period
                    </Text>
                  )}
                </FormControl>
                {/* ------------------------------------------------ Start Date / Delivery Date -------------------------------------------------------- */}
                <FormControl my={2}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Delivery Date
                  </FormLabel>
                  <DatePicker
                    placeholderText="Select delivery date"
                    className={
                      startDateError
                        ? "my-custom-datepicker dateError"
                        : "my-custom-datepicker"
                    }
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setStartDateError(false);
                    }}
                    
                    dateFormat="dd/MM/yyyy"
                    filterDate={filterDays}
                  />
                  {startDateError && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please select delivery date
                    </Text>
                  )}
                </FormControl>

                <FormControl my={2}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    End Date
                  </FormLabel>
                  <Input
                    placeholder="End date"
                    value={
                      endDate?.includes("NaN") ||
                        typeOfTenure === "" ||
                        tenurePeriod === "" ||
                        typeof startDate === 'string'
                        ? ""
                        : convertEndDate(endDate)
                    }
                    name="endDate"
                    readOnly
                  />
                </FormControl>
                <FormControl my={2} isInvalid={refundableError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Refundable Amount
                  </FormLabel>
                  <Input
                    type="number"
                    step="any"
                    placeholder="Refundable amount"
                    value={refundableAmount}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    name="refundableAmount"
                    autoComplete="off"
                    onChange={(e) => {
                      setRefundableAmount(e.target.value);
                      if (e.target.value !== "") {
                        setRefundableError(false);
                      } else {
                        setRefundableError(true);
                      }
                      if (e.target.value >= 0) {
                        setRefundablePosError(false)
                      } else {
                        setRefundablePosError(true)
                      }
                    }}
                  />
                  {(refundableError || refundablePosError) && (
                    <Text color={"red.500"} ml={1} mb={1}>
                      Please enter refundable amount  <Text as="span" color={"red.500"} mb={1}> with positive number</Text>
                    </Text>
                  )}
                </FormControl>
                <FormControl my={2} isInvalid={discountError}>
                  <FormLabel
                    fontSize={"17px"}
                    mb={1}
                    fontWeight={"semibold"}
                    letterSpacing={"wide"}
                  >
                    Discount
                  </FormLabel>
                  <Input
                    type="number"
                    step="any"
                    placeholder="Discount (%)"
                    value={discountVal}
                    isDisabled={orderDetails && Object.keys(orderDetails).length === 0}
                    name="discountPrice"
                    autoComplete="off"
                    onChange={(e) => {
                      setDiscountVal(e.target.value);
                      if (e.target.value !== "") {
                        setDiscountError(false);
                      } else {
                        setDiscountError(true);
                      }
                      if (e.target.value >= 0) {
                        setDiscountPosError(false)
                      } else {
                        setDiscountPosError(true)
                      }
                    }}
                  />
                  {(discountError || discountPosError) && (
                    <Text as="span" color={"red.500"} ml={1} mb={1}>
                      Please enter discount  <Text as="span" color={"red.500"} mb={1}> with positive number</Text>
                    </Text>
                  )}
                </FormControl>

              </CardBody>
            </Card>
          </Box>
          {/* ---------------------------- Payment details ------------------------------------- */}
          <Box flexBasis={"40%"}>
            <Card>
              <CardBody>
                <Heading
                  fontSize={"22px"}
                  fontWeight={"semibold"}
                  letterSpacing={"wide"}
                >
                  Order Item Summary
                </Heading>
                <Divider my={2} border={"1px solid gray"} />
                <Box mt={3}>
                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"48%"}
                    >
                      Base Price
                    </Text>
                    <Text flexBasis={"2%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {Number(OrderAmount)
                        .toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        ?.includes("NaN") || OrderAmount === ""
                        ? "----"
                        : `₹${Number(OrderAmount).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}
                    </Text>
                  </Flex>
                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"48%"}
                    >
                      Tenure Discount
                    </Text>
                    <Text flexBasis={"2%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {discountVal !== undefined && discountVal !== ""
                        ? `₹${(Number(OrderAmount) * (Number(discountVal) / 100)).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`
                        : "----"}
                    </Text>
                  </Flex>




                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"48%"}
                    >
                      Subtotal
                    </Text>
                    <Text flexBasis={"2%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {(Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100)))
                        .toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        ?.includes("NaN") || OrderAmount === ""
                        ? "----"
                        : `₹${(Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}
                    </Text>
                  </Flex>

                  <Flex justifyContent={"space-between"} >
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"48%"}
                      as={'div'}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                    >
                      Total Tax <Text as={'span'} fontSize={'13px'} fontWeight={'semibold'}>{`(18% GST)`}</Text>
                    </Text>
                    <Text flexBasis={"2%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) * 0.18)
                        .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2, })
                        ?.includes("NaN") || OrderAmount === ""
                        ? "----"
                        : `₹${((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) * 0.18)
                          .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}`}
                    </Text>
                  </Flex>

                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"48%"}
                    >
                      Security Deposit
                    </Text>
                    <Text flexBasis={"2%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {refundableAmount !== "undefined" &&
                        refundableAmount !== ""
                        ? "₹" +
                        Number(refundableAmount).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : "----"}
                    </Text>
                  </Flex>

                  <Flex justifyContent={"space-between"} mt={2}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"20%"}
                      fontWeight={"bold"}
                    >
                      Total
                    </Text>
                    <Text
                      flexBasis={"80%"}
                      textAlign={"right"}
                      fontWeight={"bold"}
                    >
                      {((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) + Number(refundableAmount) + ((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) * 0.18)).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                        ?.includes("NaN") || OrderAmount === ""
                        ? "----"
                        : `₹${((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) + Number(refundableAmount) + ((Number(OrderAmount) - (Number(OrderAmount) * (Number(discountVal) / 100))) * 0.18)).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}
                    </Text>
                  </Flex>
                </Box>
              </CardBody>
            </Card>
            {/* Tenure */}
            <Card mt={4}>
              <CardBody>
                <Heading
                  fontSize={"22px"}
                  fontWeight={"semibold"}
                  letterSpacing={"wide"}
                >
                  Tenure Details
                </Heading>
                <Divider my={2} border={"1px solid gray"} />
                <Box mt={3}>
                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"40%"}
                    >
                      Tenure type
                    </Text>
                    <Text flexBasis={"10%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text
                      flexBasis={"40%"}
                      textAlign={"right"}
                      letterSpacing={"wide"}
                    >
                      {typeOfTenure || "----"}
                    </Text>
                  </Flex>
                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"40%"}
                    >
                      Tenure period
                    </Text>
                    <Text flexBasis={"10%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {tenurePeriod || "----"}
                    </Text>
                  </Flex>
                  <Flex justifyContent={"space-between"}>
                    <Text
                      fontSize={"17px"}
                      mb={1}
                      letterSpacing={"wide"}
                      flexBasis={"40%"}
                    >
                      Tenure amount
                    </Text>
                    <Text flexBasis={"10%"} textAlign={"right"}>
                      :
                    </Text>
                    <Text flexBasis={"40%"} textAlign={"right"}>
                      {`₹ ${tenureAmount().toLocaleString("en-IN", {minimumFractionDigits: 2, maximumFractionDigits: 2,})}`}
                    </Text>
                  </Flex>
                </Box>
              </CardBody>
            </Card>
          </Box>
        </Flex>
      </Box>
    </Fragment>
  );
};

export default CreateOrder;
